import moment from 'moment';

import RuleUtils from './RuleUtils';

const ruleUtils = new RuleUtils();

export function isValidLat(lat) {
  return Number.isFinite(lat) && lat >= -90 && lat <= 90;
}

export function isValidLng(lng) {
  return Number.isFinite(lng) && lng >= -180 && lng <= 180;
}

const STATUS_DISPLAY_MAP = new Map([
  ['positive', 'Active'],
  ['negative', 'Resolved'],
]);

export default class AlertUtils {
  formatAlertForCsv(alert, orgsMap) {
    const {
      AlertData: { signals = [] } = {},
      DetectedAt,
      GatewayName: Asset_Name,
      GpsData: { Lat, Long } = {},
      OrgId,
      RuleName: Rule_Name,
      Transition,
      TriggeredAt,
    } = alert;
    const Detected_At = moment(DetectedAt).toISOString();
    const Org_Name = orgsMap?.[OrgId]?.name ?? '';
    const Resolved =
      Transition === 'negative' ? moment(TriggeredAt).toISOString() : '';
    const Latitude = isValidLat(Lat) ? Lat.toFixed(2) : '--';
    const Longitude = isValidLng(Long) ? Long.toFixed(2) : '--';
    const Status = STATUS_DISPLAY_MAP.get(Transition);

    return signals.reduce((acc, { name, threshold, type, value }) => {
      acc.push({
        Detected_At,
        Resolved,
        Asset_Name,
        Rule_Name,
        Org_Name,
        Latitude,
        Longitude,
        Status,
        Signal_Name: name || 'Signal Name Not Found',
        Rule_Type: ruleUtils.ruleTypeDisplayMap.get(type),
        Rule_Threshold: threshold,
        Data_Value: value,
      });
      return acc;
    }, []);
  }

  generateCsvFilename() {
    return `${new moment().format(
      'YYYY-M-D_HH\u02f8mm\u02f8ss'
    )}_Alerts Record`;
  }
}
